import React from 'react';
import './AddFormModel.css';

/**
 * Two-column form shell. Pass `rows` for correct keyboard tab order (left → right per row).
 * Legacy `leftSection` / `rightSection` tabs through entire left column then right (avoid).
 */
const AddFormModel = ({
  title,
  rowHeader,
  rows,
  leftSection,
  rightSection,
  footerActions,
  currentPractice,
  getLogoUrl,
  handleSubmit
}) => {
  const useRows = Array.isArray(rows) && rows.length > 0;

  return (
    <div className="add-form-container">
      {currentPractice && (
        <div className="ap-practice-header">
          <h3 className="ap-practice-name">{currentPractice.practice_name || 'Practice'}</h3>
          {getLogoUrl && getLogoUrl() && (
            <img
              src={getLogoUrl()}
              alt="Practice Logo"
              className="ap-practice-logo"
            />
          )}
        </div>
      )}

      <form onSubmit={handleSubmit} className="add-form-body" noValidate>
        <div className="add-form-card">
          <h3 className="add-form-card-title">{title}</h3>

          <div
            className={`add-form-content-wrap${useRows ? ' add-form-content-rows' : ''}`}
          >
            {useRows ? (
              rows.map((row, index) => (
                <div key={row.key ?? index} className="add-form-row">
                  <div className="add-form-row-col">{row.left}</div>
                  <div className="add-form-row-col">{row.right ?? null}</div>
                </div>
              ))
            ) : (
              <>
                <div className="add-form-left-section">{leftSection}</div>
                <div className="add-form-right-section">{rightSection}</div>
              </>
            )}
          </div>

          <div className="add-form-actions-wrap">
            {footerActions}
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddFormModel;
